import { bilinearSample } from "./bilinearSample";

/**
 * Apply rotation transformation to image data
 * @param imageData - ImageData to rotate
 * @param angle - Rotation angle in degrees
 * @returns New rotated ImageData
 */
export function applyRotationToImageData(
	imageData: ImageData,
	angle: number,
): ImageData {
	const width = imageData.width;
	const height = imageData.height;
	const data = imageData.data;

	// Create output image data
	const output = new ImageData(width, height);
	const outData = output.data;

	// Convert angle to radians
	const radians = (angle * Math.PI) / 180;
	const cos = Math.cos(radians);
	const sin = Math.sin(radians);

	// Center point
	const centerX = width / 2;
	const centerY = height / 2;

	// Clear output
	for (let i = 0; i < outData.length; i += 4) {
		outData[i] = 0; // Red
		outData[i + 1] = 0; // Green
		outData[i + 2] = 0; // Blue
		outData[i + 3] = 0; // Alpha (transparent)
	}

	// Apply rotation
	for (let y = 0; y < height; y++) {
		for (let x = 0; x < width; x++) {
			// Calculate source position (inverse rotation)
			const srcX = centerX + (x - centerX) * cos + (y - centerY) * sin;
			const srcY = centerY - (x - centerX) * sin + (y - centerY) * cos;

			// Bilinear sample from source
			const color = bilinearSample(data, width, height, srcX, srcY);

			const idx = (y * width + x) * 4;
			outData[idx] = color[0]; // Red
			outData[idx + 1] = color[1]; // Green
			outData[idx + 2] = color[2]; // Blue
			outData[idx + 3] = color[3]; // Alpha
		}
	}

	return output;
}
